export default __webpack_public_path__ + "static/media/pcard10.cce80a7d.png";